module.exports = __webpack_public_path__ + "static/img/blelock.383fc35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blelock.jpg
// module id = DfWQ
// module chunks = 1